import React, { useState, useRef, useEffect } from 'react';

import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';

import { TablaTickets } from './TablaTickets';

import interceptorAxios from '../../servicios/InterceptorAxios';
import { esObjetoVacio } from '../../servicios/ServicioObjetos';

export const CapturaTickets = (props) => {

    const { urlValidacionNru, funcionBusquedaNru, nrus, urlEliminarCruces } = props;

    const [cruce, setCruce] = useState({});
    const [erroresFrmCruce, setErroresFrmCruce] = useState({});

    let growl = useRef(null);

    useEffect(() => {
    }, [nrus]);

    const handleChange = (e, mayusculas) => {
        const { name, value } = e.target;
        let elValor = value;
        if (mayusculas) {
            if (elValor && typeof elValor !== 'object')
                elValor = elValor.toUpperCase();
        }
        setCruce(valoresPrevios => ({
            ...valoresPrevios,
            [name]: elValor
        }));
    };

    const validarFormularioNru = () => {
        const errores = {};
        if (!cruce.nru) {
            errores.nru = "El NRU es un valor requerido";
        }
        else if (cruce.nru.length !== 30) {
            errores.nru = "El código '" + cruce.nru + "' que capturó no corresponde a 30 dígitos, por favor verifique su captura.";
        }
        return errores;
    }

    const validarNru = () => {
        const resultadoValidacion = validarFormularioNru();
        setErroresFrmCruce(resultadoValidacion);
        if (esObjetoVacio(resultadoValidacion)) {
            interceptorAxios.post(urlValidacionNru, cruce).then(response => {
                let respuesta = response.data;
                if (respuesta.error) {
                    let erroresFrmCruce = {};
                    erroresFrmCruce.nru = respuesta.descripcionError;
                    setErroresFrmCruce(erroresFrmCruce);
                } else {
                    setCruce({});
                    funcionBusquedaNru();
                    this.growl.show({ severity: 'success', summary: 'Éxito', detail: respuesta.descripcionError });
                }
            }).catch(error => {
                console.log("error:", error);
            });
        }
    }

    return (
        <div>
            <Growl ref={growl} />
            <div className="card card-w-title">
                <h1>Conceptos a facturar</h1>
                <div className="p-grid">
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="nru">* Concepto a facturar (NRU):</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <div className="p-inputgroup">
                            <InputText id="nru" name="nru" value={cruce.nru || ''}
                                onChange={handleChange} className={erroresFrmCruce.nru ? 'p-error' : ''}
                                placeholder="NRU" size="40" />
                        </div>
                        {erroresFrmCruce.nru ? <div><br /> <Message severity="error" text={erroresFrmCruce.nru} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <Button type="submit" label="Agregar" className="p-button-rounded p-button-info" onClick={validarNru} />
                    </div>
                </div>
                <TablaTickets cruces={nrus} urlEliminarCruces={urlEliminarCruces} funcionBusquedaNru={funcionBusquedaNru} />
            </div>
        </div>
    );
}